import { TranslationMap } from '@trimble-gcs/i18n-types';

export function mapTranslations() {
  return {
    clipNoScans: {
      title: {
        text: $localize`:@@map.clipNoScans.title:No scans in clip region`,
        desc: 'Title of the dialog shown when a map clip region does not intersect any visible scans.',
      },
      message: {
        text: $localize`:@@map.clipNoScans.message:Draw a region that overlaps at least one visible scan footprint.`,
        desc: 'Message of the dialog shown when a map clip region does not intersect any visible scans.',
      },
    },
  } satisfies TranslationMap;
}
